import { cdn } from "@/dex-shared/lib/cdn";

export const loadPOCKET = async () => {
    const POCKET_CDN_URL = 'https://dnnsjdj5swfc3.cloudfront.net/front-end/libs/pocket.latest.js';
    await cdn(POCKET_CDN_URL);
    window.POCKET_ENV = { mixpanel: '760dfcc19d45ca96a003a0643baf7f3a' };
};